
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 3.667A.667.667 0 117 5a.667.667 0 010-1.334zm0 2c.368 0 .667.298.667.666v3.334a.667.667 0 01-1.334 0V6.333c0-.368.299-.666.667-.666zm0 6.666A5.34 5.34 0 011.667 7 5.34 5.34 0 017 1.667 5.34 5.34 0 0112.333 7 5.34 5.34 0 017 12.333zm0-12a6.667 6.667 0 100 13.333A6.667 6.667 0 007 .333z"}})])
          )
        }
      }
    